import api from './api';
import type { Notification } from '../types';

class NotificationsService {
  /**
   * Get all notifications
   */
  async getNotifications(): Promise<Notification[]> {
    const response = await api.get<{
      success: boolean;
      data?: Notification[];
      error?: string;
    }>('/client/notifications');

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar notificações');
  }

  /**
   * Get notification details
   */
  async getNotificationDetails(notificationId: string): Promise<Notification> {
    const response = await api.get<{
      success: boolean;
      data?: Notification;
      error?: string;
    }>(`/client/notifications/${notificationId}`);

    if (response.data.success && response.data.data) {
      return response.data.data;
    }

    throw new Error(response.data.error || 'Falha ao carregar notificação');
  }

  /**
   * Mark notification as read
   */
  async markAsRead(notificationId: string): Promise<void> {
    const response = await api.put<{
      success: boolean;
      error?: string;
    }>(`/client/notifications/${notificationId}/read`);

    if (!response.data.success) {
      throw new Error(response.data.error || 'Falha ao marcar notificação como lida');
    }
  }

  /**
   * Mark all notifications as read
   */
  async markAllAsRead(): Promise<void> {
    const response = await api.put<{
      success: boolean;
      error?: string;
    }>('/client/notifications/read-all');

    if (!response.data.success) {
      throw new Error(response.data.error || 'Falha ao marcar notificações como lidas');
    }
  }

  /**
   * Get unread notifications count
   */
  async getUnreadCount(): Promise<number> {
    const notifications = await this.getNotifications();
    return notifications.filter((n) => !n.lida).length;
  }

  /**
   * Get unread notifications
   */
  async getUnreadNotifications(): Promise<Notification[]> {
    const notifications = await this.getNotifications();
    return notifications.filter((n) => !n.lida);
  }
}

export default new NotificationsService();
